import ActivityLogUpdateMessage from "./ActivityLogUpdateMessage";
import AppStateMessage from "./AppStateMessage";
import AudioPacket from "./AudioPacket";
import BabyStationState from "./BabyStationState";
import BabyStationAudioStateMessage from "./BabyStationAudioStateMessage";
import BatteryStatus from "./BatteryStatus";
import CameraAndFlashlightState from "./CameraAndFlashlightState";
import CloudAccountSyncMessage from "./CloudAccountSyncMessage";
import DataRemoteSettings from "./DataRemoteSettings";
import DeviceUnpairedMessage from "./DeviceUnpairedMessage";
import LullabyPlayerStateMessage from "./LullabyPlayerStateMessage";
import MotionDetectorState from "./MotionDetectorState";
import MotionInfoPacket from "./MotionInfoPacket";
import RequestPairingMessage from "./RequestPairingMessage";
import RequestPairingResponseMessage from "./RequestPairingResponseMessage";
import SetVideoFlashlightMessage from "./SetVideoFlashlightMessage";
import StopCommandMessage from "./StopCommandMessage";
import StopVideoBroadcasting from "./StopVideoBroadcasting";
// import VideoFlashlightState from "./VideoFlashlightState";
import VideoRecordingDidFinishMessage from "./VideoRecordingDidFinishMessage";
import WebRTCCandidate from "./WebRTCCandidate";
import WebRTCCreateOffer from "./WebRTCCreateOffer";
import WebRTCCreateAnswer from "./WebRTCCreateAnswer";

export default {
  ActivityLogUpdateMessage,
  AppStateMessage,
  AudioPacket,
  BabyStationState,
  BabyStationAudioStateMessage,
  BatteryStatus,
  CameraAndFlashlightState,
  CloudAccountSyncMessage,
  DataRemoteSettings,
  DeviceUnpairedMessage,
  LullabyPlayerStateMessage,
  MotionDetectorState,
  MotionInfoPacket,
  RequestPairingMessage,
  RequestPairingResponseMessage,
  SetVideoFlashlightMessage,
  StopCommandMessage,
  StopVideoBroadcasting,
  // VideoFlashlightState,
  VideoRecordingDidFinishMessage,
  WebRTCCreateOffer,
  WebRTCCreateAnswer,
  WebRTCCandidate
};
